// Dependencies
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import { Pagination, Input } from 'antd';
import 'antd/dist/antd.css';
import { withTranslation, useTranslation } from 'react-i18next';

// Components
import Template from '../../components/Template';
import Spinner from '../../components/Spinner';

// hooks
import useStockStorageHook from '../../hooks/useStockStorage';
import useStatusService from '../../hooks/useStatusService';

//Images
import search from '../../../sass/images/icons/search.svg';


function Storage() {
  const { t } = useTranslation('storage');
  const { listStockStorage, reload } = useStockStorageHook();
  const parts = listStockStorage || [];
  const { newMaintenances } = useStatusService();

  const [currentPage, setCurrentPage] = useState(1);
  const [cardPerPage] = useState(6);
  const [minIndex, setMinIndex] = useState(0);
  const [maxIndex, setMaxIndex] = useState(cardPerPage);
  const [searchTerm, setSearchTerm] = useState('');

  // Filtered parts by search
  const filteredParts = parts.filter((part) => {
    const values = [part.num_part, part.component, part.description, part.quantity];
    return values.some((val) =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const handleChange = (page) => {
    setCurrentPage(page);
    setMinIndex((page - 1) * cardPerPage);
    setMaxIndex(page * cardPerPage);
  };

  return (
    <Template
      type={3}
      newMaintenances={newMaintenances}
      classNameContainer="benefit"
      className="container_menu benefit"
    >
      {!reload ? (
        <Spinner text={t('alert:reload')}> </Spinner>
      ) : (
        <div className="content_dynamic benefit_content">
          <div className="col-md-12">
            <h1 className="title-benefits">{t('titleModule')}</h1>
          </div>

          <div className="col-md-12 mb-3">
            <div className="col-md-3 filter-table">
              <div className="input-search">    
                <input
                  className="form-control no-gutters"
                  placeholder={t('searchPlaceholder')}
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                    setMinIndex(0);
                    setMaxIndex(cardPerPage);
                  }}
                  type="text"
                />
                <img src={search} alt={t('searchPlaceholder')} />
              </div>
            </div>
          </div>

          <Container
            key={1}
            className="main-card card-maintenances vehicle block-hidden driver"
          >
            <Row className="no-gutters driver table-responsive">
              <Table
                striped
                bordered
                responsive
                hover
                size="sm"
                className="table_custom mt-3"
                style={{ borderRadius: '12px' }}
              >
                <thead className="table-drivers">
                  <tr>
                    <th scope="col">{t('code')}</th>
                    <th scope="col">{t('component')}</th>
                    <th scope="col">{t('description')}</th>
                    <th scope="col">{t('quantity')}</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredParts.map(
                    (part, index) =>
                      index >= minIndex &&
                      index < maxIndex && (
                        <tr key={index}>
                          <td className="table-desktop">{part.num_part}</td>
                          <td className="table-desktop">{part.component}</td>
                          <td className="table-desktop">{part.description}</td>
                          <td className="table-desktop">{part.quantity}</td>
                        </tr>
                      )
                  )}
                </tbody>
              </Table>
            </Row>

            <Pagination
              className="col-12"
              size="small"
              defaultCurrent={1}
              total={filteredParts.length}
              defaultPageSize={cardPerPage}
              current={currentPage}
              onChange={handleChange}
            />
          </Container>
        </div>
      )}
    </Template>
  );
}

export default withTranslation(['storage'])(Storage);
